// src/Pages/CoreModules/PlanningReporting.jsx  (or wherever your page lives)
// Lean parent — only wires the header, tab nav, and active view together.
// All logic lives in the imported modules.

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TABS as LOCAL_TABS } from "../../component/Planning/mockData/PlanningData";
import PARTabNav from "../../component/Planning/PlanningTabNav";
import UnconfiguredSubmodulePlaceholder from "../../component/shared/UnconfiguredSubmodulePlaceholder";
import { useAuth } from "../../context/AuthContext";
import { useModuleTabs } from "../../config/moduleCatalog";

import {
  Workplans,
  ActivityReports,
  PARValidationHistory,
} from "../../component/Planning/PlanningTabsLive";

// Map tab key → component (capitalised variable = valid JSX element)
const TAB_VIEWS = {
  workplans:    Workplans,
  reports:      ActivityReports,
  validation:   PARValidationHistory,
};

export default function PlanningReporting() {
  const navigate  = useNavigate();
  const { pathname } = useLocation();
  const { user }  = useAuth();
  const isR05     = user?.roleId === "R05";
  const tabs = useModuleTabs("planning-reporting", LOCAL_TABS);
  const segment = pathname.split("/").filter(Boolean).pop();
  const activeTab = tabs.some((t) => t.key === segment) ? segment : tabs[0]?.key;
  const activeTabDef = tabs.find((t) => t.key === activeTab);
  const handleTabChange = (key) => navigate(`/planning-reporting/${key}`);

  // R05 only sees Workplans — lock the active view regardless of URL segment
  const ActiveView = isR05 ? Workplans : (TAB_VIEWS[activeTab] ?? Workplans);

  return (
    <div className="min-h-screen bg-white px-4 py-5 sm:p-6">

      {/* Page header */}
      <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-900 leading-none">
            Planning, Activities &amp; Operational Reporting (PAR)
          </h1>
          <p className="text-xs text-gray-400 mt-1.5">
            Activity planning, progress tracking, and report generation
          </p>
        </div>
        <span className="text-sm font-semibold text-gray-400 mt-1">FMLD-native</span>
      </div>

      {/* Tab navigation — hidden for R05 (only Workplans accessible) */}
      {!isR05 && <PARTabNav tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />}

      {/* Active tab content */}
      {!isR05 && activeTabDef?.isCatalogOnly ? (
        <UnconfiguredSubmodulePlaceholder label={activeTabDef.label} />
      ) : (
        <ActiveView />
      )}

    </div>
  );
}
